import { useMemo } from "react";

const useMediaAssets = (postData) => {
  return useMemo(() => postData.mediaAssets || postData.creatives?.map(() => null), [postData]);
};

export default useMediaAssets;
